import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';

type EditActionsProps = {
  isEditMode: boolean;
  isSecondEditMode?: boolean;
  secondEditButtonTitle?: string;
  startSecondEdit?: () => void;
  endSecondEdit?: () => void;
  saveSecondHandler?: () => void;
  startEdit: () => void;
  endEdit: () => void;
  saveHandler: () => void;
  isLoading: boolean;
  submitDisabling?: boolean;
  secondSubmitDisabling?: boolean;
};

export const EditActions: FC<EditActionsProps> = (props) => {
  const {
    isSecondEditMode,
    secondEditButtonTitle,
    startSecondEdit,
    endSecondEdit,
    saveSecondHandler,
    isEditMode,
    startEdit,
    endEdit,
    saveHandler,
    isLoading,
    submitDisabling,
    secondSubmitDisabling,
  } = props;
  const { t } = useTranslation();

  return (
    <>
      {!isSecondEditMode && secondEditButtonTitle && startSecondEdit && (
        <Button
          variant="text"
          startIcon={<EditIcon />}
          onClick={() => startSecondEdit()}
          disabled={isLoading}
        >
          {secondEditButtonTitle}
        </Button>
      )}

      {!isEditMode && !isSecondEditMode && (
        <Button
          variant="text"
          startIcon={<EditIcon />}
          onClick={() => startEdit()}
          disabled={isLoading}
        >
          {t('profile-details.action-btn.edit')}
        </Button>
      )}

      {isEditMode && (
        <>
          <Button
            variant="contained"
            onClick={() => saveHandler()}
            disabled={isLoading || submitDisabling}
          >
            {t('profile-details.action-btn.save')}
          </Button>

          <Button variant="outlined" onClick={() => endEdit()} disabled={isLoading}>
            {t('profile-details.action-btn.cancel')}
          </Button>
        </>
      )}

      {isSecondEditMode && saveSecondHandler && endSecondEdit && (
        <>
          <Button
            variant="contained"
            onClick={() => saveSecondHandler()}
            disabled={isLoading || secondSubmitDisabling}
          >
            {t('profile-details.action-btn.save')}
          </Button>

          <Button variant="outlined" onClick={() => endSecondEdit()} disabled={isLoading}>
            {t('profile-details.action-btn.cancel')}
          </Button>
        </>
      )}
    </>
  );
};
